var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Header'),_c('Map'),_c('FilterPanel'),(!_vm.introDismissed)?_c('Intro'):_vm._e(),_c('SidePanel',[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }